import { createContext } from "react";
import noop from "lodash-es/noop";
export var DEFAULT_ACCOUNT_CONTEXT_STATE = {
    ready: false,
    loading: false,
    account: null,
};
export var AccountContext = createContext({
    active: false,
    sdkReady: (function () {
        throw new Error("[@hg/one-account] Account provider miss sdk");
    }),
    events: { login: [], logout: [] },
    onError: function (_, err) { return console.error(err); },
    customLoginDialog: false,
    state: DEFAULT_ACCOUNT_CONTEXT_STATE,
    dispatch: noop,
});
